import { StaticPageLoadingPlaceholder } from '@cp-shared-10/frontend-ui';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import React from 'react';
import { CookiePolicyUi } from './ui';
import { useCookiePolicy } from './useCookiePolicy';

const CookiePolicyWithHandlers = withLoadingAndNoConnectionHandler(CookiePolicyUi);

export const CookiePolicy: React.FC = () => {
    const { cmsContent: cookiePolicy, isLoading, loadingError } = useCookiePolicy();

    return (
        <CookiePolicyWithHandlers
            isLoading={isLoading}
            cookiePolicy={cookiePolicy}
            hasError={!!loadingError}
            loadingPlaceholder={<StaticPageLoadingPlaceholder />}
        />
    );
};
